export default "__VITE_ASSET__BJotrZN0__"